import { Stats } from "@/pages/Index/StatsSection";
import { createContext, useContext } from "react";

type StatsContextType = {
    stats: Stats,
    setStats: React.Dispatch<React.SetStateAction<Stats>>;
};
export const StatsContext = createContext<StatsContextType | undefined>(undefined);

export function useStatsContext() {
    const ctx = useContext(StatsContext);
    if (!ctx) throw new Error("useStatsContext must be used within a StatsProvider");
    return ctx;
}